import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]

import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import { computed, ref } from 'vue';
import { useStore } from '@store/index';
import { useTranslations } from '@helper/composables/translations';

export default /*@__PURE__*/_defineComponent({
  __name: 'ShowMoreToggle',
  props: {
    labelMore: {},
    labelLess: {}
  },
  emits: ['ShowMoreToggle:onToggle'],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const { translate } = useTranslations();

const props = __props;

const label = computed(() => {
	const labelOpen = props.labelMore ?? translate('showMoreToggle.more');
	const labelClose = props.labelLess ?? translate('showMoreToggle.less');
	return isOpen.value ? labelClose : labelOpen;
});

const isMobile = computed(() => !store.state.config.isMinTablet);

const emit = __emit;
const isOpen = ref(false);
const toggle = () => {
	emit('ShowMoreToggle:onToggle', !isOpen.value);
	isOpen.value = !isOpen.value;
};

return (_ctx: any,_cache: any) => {
  return (isMobile.value)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        "aria-label": label.value,
        class: "toggle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle()))
      }, [
        _createTextVNode(_toDisplayString(label.value) + " ", 1 /* TEXT */),
        _createVNode(BaseIcon, {
          name: "chevron",
          width: "24",
          height: "24",
          class: _normalizeClass(["toggle__arrow", { open: isOpen.value }])
        }, null, 8 /* PROPS */, ["class"])
      ], 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}
}

})